// actionTypes.js
const ActionTypes = {
  SET_STATE: "SET_STATE",
    SET_ERROR: "SET_ERROR",
    SET_LOADING: "SET_LOADING",
    SEARCHING_RESULTS: "SEARCHING_RESULTS",
    SET_FILTERS_QUERY:"SET_FILTERS_QUERY",
    SET_FILTERED_COURSES: "SET_FILTERED_COURSES",
    CLEAR_FILTERS:"CLEAR_FILTERS",
    SET_SORTING_PARAMETERS:'SET_SORTING_PARAMETERS',
   
    

    HANDLE_RESET_FILTER: "HANDLE_RESET_FILTER",
    SET_SEARCH_TERM: "SET_SEARCH_TERM",
  
 
   
  };
  
  export default ActionTypes;
  